import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace FHRallyObedience {
  export const form: IEventRegisterRow[] = [
    {
      inputs: [{
        type: "checkbox",
        multiSelect: false,
        label: Constants.show_type.rally_obedience,
        options: [
          { value: Constants.dog_class_element_level.fh_rally_foundation_3_7,    id: Constants.dog_class_element_level.fh_rally_foundation_3_7 },
          { value: Constants.dog_class_element_level.fh_rally_foundation_8_up,   id: Constants.dog_class_element_level.fh_rally_foundation_8_up },
          { value: Constants.dog_class_element_level.fh_rally_novice_3_7,        id: Constants.dog_class_element_level.fh_rally_novice_3_7 },
          { value: Constants.dog_class_element_level.fh_rally_novice_8_up,       id: Constants.dog_class_element_level.fh_rally_novice_8_up },
          { value: Constants.dog_class_element_level.fh_rally_intermediate_3_7,  id: Constants.dog_class_element_level.fh_rally_intermediate_3_7 },
          { value: Constants.dog_class_element_level.fh_rally_intermediate_8_up, id: Constants.dog_class_element_level.fh_rally_intermediate_8_up },
          { value: Constants.dog_class_element_level.fh_rally_advanced_3_7,      id: Constants.dog_class_element_level.fh_rally_advanced_3_7 },
          { value: Constants.dog_class_element_level.fh_rally_advanced_8_up,     id: Constants.dog_class_element_level.fh_rally_advanced_8_up },
          { value: Constants.dog_class_element_level.fh_rally_excellent,         id: Constants.dog_class_element_level.fh_rally_excellent },
          { value: Constants.dog_class_element_level.fh_rally_masters,           id: Constants.dog_class_element_level.fh_rally_masters },
        ]
      }]
    }
  ];
}
